module.exports = __webpack_public_path__ + "static/media/pres-banner.de824237.webp";